export class OSVersionModel {
    public OS: string;
    public OSName: string;
    public BrowserName: string;
    public Version: string;
  
  }